import { createAction, props } from '@ngrx/store';
import { IToDoResponse } from '../../todos/models/todos.model';
import { ISearchExistingUserLegalEntitySetup } from '../models/search-existing-user.model';

export const loadSearchExistingUsers = createAction(
  '[Legal Entity Setup SearchExistingUser] Load SearchExistingUsers',
  props<{ request: ISearchExistingUserLegalEntitySetup }>()
);

export const loadSearchExistingUsersSuccess = createAction(
  '[Legal Entity Setup SearchExistingUser] Load SearchExistingUsers Success',
  props<{ response: IToDoResponse }>()
);

export const loadSearchExistingUsersFailure = createAction(
  '[Legal Entity Setup  SearchExistingUser] Load SearchExistingUsers Failure',
  props<{ error: Error | any }>()
);
